import { GetEntitiesInDto, GetEntitiesOutDto } from "../../../types/enargas.dto"

export const GET_ENTITY = 'GET_ENTITY'
export const GET_ENTITY_SUCCESS = 'GET_ENTITY_SUCCESS'
export const GET_ENTITY_ERROR = 'GET_ENTITY_ERROR'
export const RESET_GET_ENTITY = 'RESET_GET_ENTITY'
export interface GetEntity {
  type: typeof GET_ENTITY
  payload: GetEntitiesOutDto
}

export interface GetEntitySuccess {
  type: typeof GET_ENTITY_SUCCESS
  payload: any
}

export interface GetEntityError {
  type: typeof GET_ENTITY_ERROR
  payload: string | boolean
}

export interface ResetGetEntity {
  type: typeof RESET_GET_ENTITY
  payload: null
}

export interface State {
  data: GetEntitiesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetEntity
  | GetEntitySuccess
  | GetEntityError
  | ResetGetEntity
